interface NodeInfoLink {
  rel: string;
  href: string;
}

interface NodeInfoResponse {
  links: NodeInfoLink[];
}

interface NodeInfoData {
  version: string;
  software: {
    name: string;
    version: string;
  };
}

let cachedSoftwareName: string | null = null;
let detectionPromise: Promise<string> | null = null;

export async function detectInstanceSoftware(baseUrl: string): Promise<string> {
  if (cachedSoftwareName) {
    return cachedSoftwareName;
  }

  if (detectionPromise) {
    return detectionPromise;
  }

  detectionPromise = (async () => {
    try {
      const wellKnownUrl = `${baseUrl}/.well-known/nodeinfo`;
      const wellKnownResponse = await fetch(wellKnownUrl);

      if (!wellKnownResponse.ok) {
        return 'unknown';
      }

      const wellKnownData =
        (await wellKnownResponse.json()) as NodeInfoResponse;

      const nodeInfo2Link =
        wellKnownData.links.find(
          (link) =>
            link.rel === 'http://nodeinfo.diaspora.software/ns/schema/2.1',
        ) ??
        wellKnownData.links.find(
          (link) =>
            link.rel === 'http://nodeinfo.diaspora.software/ns/schema/2.0',
        );

      if (!nodeInfo2Link) {
        return 'unknown';
      }

      const nodeInfoResponse = await fetch(nodeInfo2Link.href);

      if (!nodeInfoResponse.ok) {
        return 'unknown';
      }

      const nodeInfoData = (await nodeInfoResponse.json()) as NodeInfoData;
      cachedSoftwareName = nodeInfoData.software.name.toLowerCase();

      return cachedSoftwareName;
    } catch (error) {
      console.error('Failed to detect instance software:', error);
      return 'unknown';
    }
  })();

  return detectionPromise;
}

export function getCachedSoftwareName(): string | null {
  return cachedSoftwareName;
}
